const style = {
  footer: {
    marginTop: 'auto',
    fontSize: 12,
    color: '#888'
  }
}

export default style
